import ApiClient from '../ApiClient';

const appId = process.env.REACT_APP_DEFAULT_APP_ID; //pass the app ID based on login

const TemplateService = {
  async fetchTemplates() {
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.get(`/Template/getall-templates`);
    return resp;
  },

  async createTemplate(formData){
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.post("/Template/create-template", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return resp;
  },

  async createEventImage(formData){
    if (!appId) throw new Error('appId is required');
    const resp = await ApiClient.post("/Template/template-image", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
    return resp;
  }

};



export default TemplateService;
